import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        d="M59.7,15.1C50.8,0.4,34.1,1,33,1c-1.1,0.1-18.3,0.2-26.7,14c-5.7,9.5-6.4,26.2-4.1,39C3.4,59.8,9.5,87,33,87
	s29.6-27.2,30.7-33C66.1,41.2,65.4,24.5,59.7,15.1z"
      />
    </g>
  )
}
